import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { NetworkService, ConnectionStatus } from './services/network.service';
import { OfflineManagerService } from './services/offline-manager.service'
import { ApiService } from './services/api.service';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { BehaviorSubject } from 'rxjs';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  userprofile:any;
  app_user:string;
  uploadedDocuments:[{}];
   // Form Validation
   filterTerm: string;
   filterPub:string;
   filterEvent:string; 
   sliderOne: any;
   sliderTwo: any=[];
   sliderThree: any;
   cp: number = 1;
   pb: number = 1;
   eb: number = 1; 
   loading: boolean = false;
   themes: any[];
   tags: any;
   videos: any;
   publications: any;
   events: any;
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private offlineManager: OfflineManagerService,
    private networkService: NetworkService,
    private authenticationService: ApiService,
    private storage: Storage,
    private router: Router,
    private apiService: ApiService,
  ) {
    this.initializeApp();
  }
  ngOnInit() {
    let themes = this.storage.get('specialkey-themes').then((response) => {
      this.themes = response;
    });
    let tags = this.storage.get('specialkey-tags').then((response) => {
      this.tags = response;
    });
    let Front_page_videos = this.storage.get('specialkey-videos_frontpage').then((response) => {
      this.videos = response;
    });
    let Front_page_pubs = this.storage.get('specialkey-publications').then((response) => {
      this.publications = response;
    });
    let Front_page_events = this.storage.get('specialkey-events').then((response) => {
      this.events = response;
    });
    let Front_page_slider = this.storage.get('specialkey-sliders').then((response) => {
      this.sliderTwo = response;
    });
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      // mine
      this.networkService.onNetworkChange().subscribe((status: ConnectionStatus) => {
        if (status == ConnectionStatus.Online) {
          this.offlineManager.checkForEvents().subscribe();
        }
      });
      //Check if User exist locally
      // this.authenticationService.authState.subscribe(state => {
      //   if (state) {
      //     //populate userprofile 
      //     this.router.navigate(['/account']);
      //   } else {
      //     this.router.navigate(['/welcome']);
      //   }
      // });
      //End of Check User exist

    });
  }

  // Data Services
  getThemes(){
    let endpoint="thematic-areas?populate=%2A";
    let data_key="themes";
    this.apiService.getRecord(true,endpoint,data_key).subscribe(res =>{
    
    });
  }
  getDistricts(){
    let endpoint="districts";
    let data_key="districts";
    this.apiService.getRecord(true,endpoint,data_key).subscribe(res =>{   
    });
  }
  getLanguages(){
    let endpoint="languages";
    let data_key="languages";
    this.apiService.getRecord(true,endpoint,data_key).subscribe(res =>{  
       
    });
  }
  getTags(){
    let endpoint="tags";
    let data_key="tags";
    this.apiService.getRecord(true,endpoint,data_key).subscribe(res =>{  

    });
  }
  // getVideos(){
  //   let endpoint="videos?populate=%2A";
  //   let data_key="videos_frontpage";
  //   this.apiService.getRecord(true,endpoint,data_key).subscribe(res =>{  
      
  //   });
  // }
  getVideos(){
    let endpoint="videos?pagination%5BwithCount%5D=false&pagination%5BpageSize%5D=100";
    let data_key="videos_frontpage";
    this.apiService.getRecord(true,endpoint,data_key).subscribe(res =>{  
      
    });
  }
  getEvents(){
    let endpoint="events?populate=%2A";
    let data_key="events";
    this.apiService.getRecord(true,endpoint,data_key).subscribe(res =>{  
      
    });
  }
  getPublications(){
    let endpoint="Publications?populate=%2A";
    let data_key="publications";
    this.apiService.getRecord(true,endpoint,data_key).subscribe(res =>{  
  
    });
  }
  getSliders(){
    let endpoint="sliders?populate=%2A";
    let data_key="sliders";
    this.apiService.getRecord(true,endpoint,data_key).subscribe(res =>{  
  
    });
  }
  getBookmarks(){
    let endpoint="video-bookmarks?populate=%2A";
    let data_key="bookmarks";
    this.apiService.getRecord(true,endpoint,data_key).subscribe(res =>{  
  
    });
  }
  getSubscibers(){
    let endpoint="subscribers?populate=%2A";
    let data_key="subscribers";
    this.apiService.getRecord(true,endpoint,data_key).subscribe(res =>{  
  
    });
  }
}
